<template>
  <div class="full-page-width relative locations">
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('notification-info-text')"
          :title="$t('Notifications')"
          :btnText="$t('add_notification')"
          @action="openNewPopup" />
      </div>
      <div class="col-xs-8">
        <ul class="list-table">
          <li
            class="list-table-item"
            @click="goToMessage(item.id)"
            v-for="(item, index) in get_notifications.items" :key="`item-${index}`">
            <div class="table-cell small">
              <div class="list-icon-block">
                <div class="status-indicator" :class="item.is_enabled == true ? 'active' : 'inactive'"></div>
                <Icon
                  :circle=true
                  name="letter"
                  size="20"/>
              </div>
            </div>
            <div class="table-cell">
              <p>
              <span class="main-info">
                {{ `${item.subject || '-'}` }}
              </span>
                <span class="additional-info">
                  {{ `${$t(get_notifications.entity.notification_type[item.notification_type])} ` + getSenderText(item) }}
                </span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Popup
      v-if="openPopup"
      :popupSmall=true
      :isPopupSubmitDisabled="isPopupSubmitDisabled"
      @cancel="togglePopup"
      @confirm="submitForm">
      <template v-slot:header>
        <h2>{{ $t('add_notification') }}</h2>
      </template>
      <div>
        <div class="row">
          <div class="col-xs-12 m-b-20" v-if="get_user.is_admin">
            <InputSelect
              class="m-b-20"
              :multiSelect=true
              :preselected="form.accessible_for_subaccounts"
              :label="$t('accessible_for_accounts')"
              @change="selectAccessibleSubaccount"
              :rules="{required: true}"
              :options="getAllowedSubaccounts" />
          </div>
          <div class="col-xs-12 m-b-20">
            <InputSelect
              :label="$t('notification_type')"
              v-model="form.notification_type"
              :options="selectOptions(get_notifications.entity['notification_type'])"
              :rules="{required: true}"
              @input="handleNotificationTypeChange" />
          </div>
          <div class="col-xs-12 m-b-20">
            <InputSelect
              :label="$t('notification_by')"
              v-model="form.notification_by"
              :options="filteredNotificationByOptions"
              :rules="{required: true}" />
          </div>
          <div class="col-xs-12 m-b-20" v-if="form.notification_by === 1">
            <InputSelect
              :label="$t('SMTP')"
              v-model="form.smtp_id_and_type"
              :options="get_all_smtps_options"
              :rules="{required: true}" />
          </div>
          <div class="col-xs-12 m-b-20">
            <InputSelect
              :label="$t('direction_type')"
              v-model="form.direction_type"
              :options="selectOptions(get_notifications.entity['direction_type'])"
              :rules="{required: true}" />
          </div>
          <div class="col-xs-12 m-b-20">
            <InputSelect
              :label="$t('apply_for_shipper')"
              v-model="form.sender_id"
              :options="get_senders_options"
              :rules="{required: true}" />
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import InputSelect from '@/components/elements/inputs/select.vue';

import InfoTextBox from '@/components/global/infoTextBox';
import formValidator from '@/mixins/formValidator';

export default {
  name: 'Packages',
  mixins: [formValidator],
  components: { Btn, Popup, InputText, InputSelect, InfoTextBox },
  data() {
    return {
      openPopup: false,
      isEdit: false,
      notificationId: '',
      form: {
        accessible_for_subaccounts: [],
        notification_type: '',
        notification_by: '',
        smtp_id_and_type: '',
        sender_id: '',
        direction_type: ''
      },
      notificationByRules: {
        // Define which notification_by options are allowed for each notification_type
        7: [1, 2], // Email and sms allowed
        // Add more rules for other notification types as needed
        DEFAULT: [1] // Only email allowed by default
      }
    };
  },
  computed: {
    ...mapGetters([
      'get_notifications',
      'get_notification_by_id',
      'get_all_smtps_options',
      'get_senders_options',
      'get_senders',
      'get_subaccounts',
      'get_user'
    ]),
    filteredNotificationByOptions() {
      // Get the allowed notification_by options based on the selected notification_type
      const notificationType = this.form.notification_type;
      const allowedOptions = this.notificationByRules[notificationType] || this.notificationByRules.DEFAULT;

      // Get all notification_by options
      const allOptions = this.selectOptions(this.get_notifications.entity['notification_by']);

      // Filter options based on allowed values
      return allOptions.filter(option => allowedOptions.includes(option.value));
    },
    isPopupSubmitDisabled() {
      if(this.get_user.is_admin && this.form.accessible_for_subaccounts.length == 0) return true;
      const formWithValidators = [
        {
          formFeild:'notification_type',
          value: this.form.notification_type,
          validators:{required: true}
        },
        {
          formFeild:'notification_by',
          value: this.form.notification_by,
          validators:{required: true}
        },
        {
          formFeild:'smtp_id_and_type',
          value: this.form.smtp_id_and_type,
          validators:{required: this.form.notification_by === 1}
        },
        {
          formFeild:'direction_type',
          value: this.form.direction_type,
          validators:{required: true}
        },
        {
          formFeild:'sender_id',
          value: this.form.sender_id,
          validators:{required: true}
        },
      ]

      return this.validateInput(formWithValidators);
    },
    getAllowedSubaccounts() {
      return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(String(acc.id)) > -1).map((acc) => ({text: acc.name, value: String(acc.id),}));
    },
  },
  created() {
    this.$store.dispatch('GET_NOTIFICATIONS');
    this.$store.dispatch('GET_ALL_SMTPS');
    this.$store.dispatch('GET_SENDERS');
  },
  methods: {
    handleNotificationTypeChange() {
      // Reset notification_by when notification_type changes
      this.form.notification_by = '';
      this.form.smtp_id_and_type = '';
    },
    selectAccessibleSubaccount(val) {
      this.form.accessible_for_subaccounts = val;
    },
    selectOptions(obj) {
      const options = [];
      for (const property in obj) {
        options.push({ text: obj[property], value: parseInt(property) });
      }
      return options;
    },
    getSenderText(item) {
      const name  = item.sender_company_name ? item.sender_company_name : item.sender_name;
      return name ? `${this.$t('for')} ${name}` : '';
    },
    clearLocalFormData() {
      this.form = {
        accessible_for_subaccounts: [],
        notification_type: '',
        notification_by: '',
        smtp_id_and_type: '',
        direction_type: '',
        sender_id: '',
      };
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
      this.packageId = '';
      this.clearLocalFormData();
    },
    submitForm() {
      const action = this.isEdit ? 'EDIT_NOTIFICATION' : 'SET_NOTIFICATION';
      this.form.accessible_for_subaccounts = this.form.accessible_for_subaccounts.filter((val) => this.get_user.accessible_subaccounts_array.indexOf(String(val)) > -1);

      this.$store.dispatch(`${action}`, {
        form: this.form,
        id: this.notificationId || '',
      }).then(() => {
        this.$store.dispatch('GET_NOTIFICATIONS');
        this.openPopup = false;
        this.clearLocalFormData();
      });
    },
    goToMessage(id) {
      this.$router.push({ path: `/settings/shipping/customize-notification/${id}` });
    },
    openNewPopup() {
      this.isEdit = false;
      this.togglePopup();
    },
    openEditPopup(id) {
      this.togglePopup();
      this.isEdit = true;
      this.notificationId = id;
      this.form = { ...this.get_notification_by_id(id) };
    },
  },
};
</script>

